<template>
  <div class="box">
    <div class="option" v-for="option in options" v-bind:key="option.id" :data-id="option.id" @click="clickOption">
      <span>{{option.option}}</span>
    </div>


  </div>
</template>

<script>
import common from "../../common";
import $ from 'jquery';

export default {
  name: "SurveyFinishType",
  data() {
    return {
      options: [
        {id: 1, option: '1、完全不能， 需要有人輔助'},
        {id: 2, option: '2、未必能夠，可能要一點幫忙'},
        {id: 3, option: '3、不能肯定，應可自己嘗試'},
        {id: 4, option: '4、應該可以'},
        {id: 5, option: '5、完全可以'},
      ],
      i: 0,
      time: [14.5, 5, 5, 4.2, 5],
      timeout_init: null,
      timeout: null,
      inter: null,
    }
  },
  mounted() {
    common.getUserInfo().then(user_info => {
      common.getStorage('is_literate_' + user_info.id).then(is_literate => {
        if (!is_literate) {
          this.flicker();
        }
      })
    })
  },
  unmounted() {
    clearInterval(this.inter)
    clearTimeout(this.timeout_init)
    clearTimeout(this.timeout)
  },
  methods: {
    clickOption: function (e) {
      const objs = document.getElementsByClassName('option');
      for (let i = 0; i < objs.length; i++) {
        objs[i].classList.remove('selected');
      }

      let id = 0;
      if ($(e.target).hasClass('option')) {
        e.target.classList.add('selected')
        id = e.target.dataset.id;
      } else {
        $(e.target).parent().addClass('selected')
        id = $(e.target).parent().data('id')
      }

      this.$emit('getFinishType', id);
    },
    flicker: function () {
      const time = this.time[this.i]
      const i = this.i;

      if (!time) {
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;

      this.timeout_init = setTimeout(function () {
        that.inter = setInterval(function () {
          $('.option').eq(i).find('span').toggleClass('hide-ele')
        }, 400)
      }, i === 0 ? 8000 : 0)

      this.timeout = setTimeout(function () {
        clearInterval(that.inter)
        $('.option').eq(i).find('span').removeClass('hide-ele')
        that.flicker();

      }, time * 1000)

      this.i++;

    }
  }
}
</script>

<style scoped>
.box{
  text-align: center;
  /*margin-top: 16vh;*/
  position: relative;
}
.option{
  text-align: left;
  font-size: var(--ecs-font-md);
  min-height: var(--ecs-option-min-height);
  width: var(--ecs-control-width-lg);
  max-width: 90vw;
  border-radius: var(--ecs-radius-md);
  margin: 0 auto;
  line-height: 1.2;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  white-space: normal;
  cursor: default;
}
.selected{
  background: #94c43b;
  color: white;
}
.hide-ele{
  visibility:hidden;
}
</style>
